import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Briefcase, FolderKanban, Building2, MessageSquareQuote,
  Camera, Inbox, Settings, LogOut, ExternalLink, BarChart3, Zap,
} from "lucide-react";
import { useAuth } from "../../lib/auth";

const navItems = [
  { to: "/admin/dashboard", label: "Panel", icon: LayoutDashboard },
  { to: "/admin/analytics", label: "Analiz", icon: BarChart3 },
  { to: "/admin/projects", label: "Projeler", icon: FolderKanban },
  { to: "/admin/shorts", label: "Viral İşler", icon: Zap },
  { to: "/admin/services", label: "Hizmetler", icon: Briefcase },
  { to: "/admin/brands", label: "Markalar", icon: Building2 },
  { to: "/admin/testimonials", label: "Yorumlar", icon: MessageSquareQuote },
  { to: "/admin/bts", label: "Sahne Arkası", icon: Camera },
  { to: "/admin/messages", label: "Mesajlar", icon: Inbox },
  { to: "/admin/settings", label: "Ayarlar", icon: Settings },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#08080D] text-white flex">
      <aside className="w-64 border-r border-white/5 bg-[#0A0A11] flex flex-col shrink-0">
        <div className="p-6 border-b border-white/5">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#A855F7] shadow-[0_0_12px_rgba(168,85,247,0.9)]" />
            <span className="font-display text-sm tracking-[0.2em] uppercase">İxirli</span>
          </div>
          <div className="mt-1 text-[10px] tracking-widest text-white/40 uppercase font-mono-ui">
            Studio Panel
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={`nav-${it.to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive ? "bg-[#A855F7]/15 text-white border border-[#A855F7]/30" : "text-white/60 hover:text-white hover:bg-white/5 border border-transparent"
                }`
              }
            >
              <it.icon size={15} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5 space-y-1">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-white/60 hover:text-white hover:bg-white/5"
          >
            <ExternalLink size={14} /> Siteyi Görüntüle
          </a>
          <button
            data-testid="admin-logout"
            onClick={() => { logout(); nav("/admin"); }}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-red-400 hover:bg-red-500/10"
          >
            <LogOut size={14} /> Çıkış Yap
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <header className="border-b border-white/5 px-8 py-4 flex items-center justify-between">
          <div className="text-xs tracking-widest uppercase text-white/50 font-mono-ui">Admin · {user?.username}</div>
          <div className="text-xs tracking-widest uppercase text-[#A855F7] font-mono-ui">v1.0</div>
        </header>
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
